/*
 * @Date: 2022-12-27 15:21:01
 * @LastEditors: Leo
 * @LastEditTime: 2023-06-07 15:33:57
 * @FilePath: \3.0-manger\src\js\components\details-modal.js
 */
import { stopVideo, autoplayVideo, setContentWidth, resetContentWidth, } from '../../utils/index'
import './index.css'
export default class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');

    if(this.querySelector('.jackery-icon-guanbi')) {
      this.querySelector('.jackery-icon-guanbi').addEventListener(
        'click',
        () => {
          this.close()
        }
      );
    }

    if(this.detailsContainer.querySelector('video')) {
      const vv = this.detailsContainer.querySelector('video')
      vv.onloadedmetadata = () => {
        const vmc = this.detailsContainer.querySelector('.video-modal__content')
        if(vmc) {
          vmc.style.height = '80vh'
          vmc.style.width = 80 * vv.videoWidth / vv.videoHeight + 'vh'
        }
      }
    }

    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close(false, event)
      : this.open(event);


      // fixed:博客搜索 - scrolltop
      if(window.location.pathname.indexOf("/pages/blogs") !== -1 && event.target.closest('details').hasAttribute('open') && event.target.getAttribute("data-type") === "blog-search-toggle") {
        $(".blog-cate") && $('html, body').animate({
          scrollTop: $(".blog-cate").offset().top
        }, 200);
      }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    // 设置 内容区域 宽度，防止 页面闪烁
    setContentWidth()
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"],[disabled])')
    );

    autoplayVideo(this.detailsContainer)
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    // 恢复 内容区域 宽度
    resetContentWidth()
    stopVideo(this.detailsContainer)
  }
}
